import React, { useState } from "react";
import { FaPeopleGroup } from "react-icons/fa6";
import aboutc1 from "../../asset/images/aboutc1.webp";
import aboutc2 from "../../asset/images/aboutc2.webp";
import aboutt1 from "../../asset/images/aboutt1.svg";

import { FaCaretRight } from "react-icons/fa";
import { PopupModal } from "react-calendly";
import { useNavigate } from "react-router-dom";

const AboutCommitment = () => {

  const navigate = useNavigate();
  const [calpop, setCalpop] = useState(false);

  return (
    <>
    <PopupModal
        url="https://calendly.com/team-metbrains/30min"
        onModalClose={() => setCalpop(false)}
        open={calpop}
        rootElement={document.getElementById("root")}
      />
    <div className="about_commitment">
      <div className="container">
        <h2>
          <span>
            Our commitment, inclusive framework and focus on social
          </span>
          <em> impact</em>
        </h2>

        <div className="about_commitment_first">
          <div className="about_commitment_first_left">
            <h3>Career-First Learning</h3>
            <p>
            We are dedicated to ensuring every learner gains not just knowledge, but practical skills that lead to measurable career outcomes. From resume guidance to real-world projects, our programs are built to empower futures.
            </p>
            <span style={{cursor:"pointer"}} onClick={()=>{navigate("/programs")}}>
              <FaPeopleGroup />
              Program journey
              <FaCaretRight />
            </span>
          </div>
          <img src={aboutc1} alt="" />
        </div>
        <div className="about_commitment_first about_commitment_second">
          <div className="about_commitment_first_left">
            <h3>Accessible & Inclusive Mentorship</h3>
            <p>
            The world evolves quickly—and so should education. We constantly adapt our programs to reflect industry demands, ensuring learners stay ahead with future-ready skills. Our commitment extends to fostering equal opportunities in tech and analytics. We support learners from varied backgrounds, building a community where collaboration, inclusivity, and growth go hand in hand.
            </p>
            <span style={{cursor:"pointer"}} onClick={()=>{navigate("/reviews")}}>
              <FaPeopleGroup />
              Candidate Journey
              <FaCaretRight />
            </span>
          </div>
          <img src={aboutc2} alt="" />
        </div>

        <div className="about_commitment_talk">
          <h2>
            <span>Talk to Metbrains: </span>
            <em>Find out how we can help</em>
          </h2>
          <div className="about_commitment_talk_flex">
            <div className="about_commitment_talk_card">
              <div className="about_commitment_talk_header">
                <img src={aboutt1} alt="" />
                <span>
                  <h4>Stay ahead with data-driven decisions</h4>
                  <p>
                    Download our latest reports to explore hiring trends and
                    industry benchmarks.
                  </p>
                  <button onClick={()=>{navigate("/programs")}} className="neo-xnmrph-btn-orange">Browse the programs</button>
                </span>
              </div>
            </div>
            <div className="about_commitment_talk_card">
              <div className="about_commitment_talk_header">
                <img src={aboutt1} alt="" />
                <span>
                  <h4>Ready to find the right mentorship?</h4>
                  <p>
                    Connect with our expert team today to discuss your
                    career needs.
                  </p>
                  <button onClick={()=>{setCalpop(true)}} className="neo-xnmrph-btn-blue">Talk to our counselor</button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default AboutCommitment;
